export const shortTestimonials = [
  {
    initials: 'MV',
    name: 'Mariana V.',
    place: 'Buenos Aires',
    quote: 'Llegué con la carpeta ordenada. El neurólogo me dijo que estaba muy bien preparada. Finalmente me sentí escuchada.'
  },
  {
    initials: 'FG',
    name: 'Fernanda G.',
    place: 'Córdoba',
    quote: 'Mis observaciones organizadas hicieron la consulta mucho más productiva que antes.'
  },
  {
    initials: 'GT',
    name: 'Graciela T.',
    place: 'Rosario',
    quote: 'Con el sistema llegué organizada y la consulta fue completamente diferente. Me sentí como una aliada en el proceso.'
  }
] as const;

export const extendedTestimonials = [
  {
    name: 'Mariana V.',
    place: 'Buenos Aires',
    quote: '“El neurólogo me dijo que estaba muy bien preparada. Por primera vez sentí que realmente me escuchaba.”'
  },
  {
    name: 'Fernanda G.',
    place: 'Córdoba',
    quote: '“Mis observaciones organizadas hicieron la consulta mucho más productiva que antes.”'
  },
  {
    name: 'Graciela T.',
    place: 'Rosario',
    quote: '“Llegué organizada y la consulta fue completamente diferente. Me sentí como una aliada en el proceso.”'
  },
  {
    name: 'Karina D.',
    place: 'Mendoza',
    quote: '“Sé qué observar, cómo registrarlo y qué llevar. Llego preparada y eso me calma.”'
  }
] as const;

export const purchases = [
  ['Mariana V.', 'Buenos Aires'],
  ['Fernanda G.', 'Córdoba'],
  ['Graciela T.', 'Rosario'],
  ['Karina D.', 'Mendoza']
] as const;
